import type { AnchorHTMLAttributes, ComponentType, RefAttributes } from 'react';
import React, { createContext, forwardRef, useContext } from 'react';

export type LinkComponentProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  RefAttributes<HTMLAnchorElement> & {
    href: string;
  };

export type LinkComponent = ComponentType<LinkComponentProps>;

export const DefaultLinkComponent = forwardRef<
  HTMLAnchorElement,
  LinkComponentProps
>((props, ref) => {
  return <a ref={ref} {...props} />;
});

export const LinkComponentContext = createContext<LinkComponent>(
  DefaultLinkComponent
);

export const useLinkComponent = () => {
  const linkComponent = useContext(LinkComponentContext);

  return linkComponent;
};
